import { render, staticRenderFns } from "./StudentSidebar.vue?vue&type=template&id=0c5673f8&scoped=true&lang=pug&"
import script from "./StudentSidebar.vue?vue&type=script&lang=ts&"
export * from "./StudentSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSidebar.vue?vue&type=style&index=0&id=0c5673f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5673f8",
  null
  
)

export default component.exports